@@include('../assets/jquery-1.8.2.min.js');
@@include('../assets/jquery.maskedinput-1.3.min.js');
@@include('../assets/bootstrap/js/bootstrap.min.js');
@@include('../assets/underscore.min.js');
@@include('../assets/path.min.js');
@@include('../assets/fancybox/jquery.mousewheel-3.0.4.pack.js');
@@include('../assets/fancybox/jquery.fancybox-1.3.4.pack.js');
@@include('../assets/jquery.maskedinput-1.3.js');
@@include('../assets/lightslider.min.js');
@@include('../assets/owlcarousel/owl.carousel.min.js');
@@include('init.min.js');
@@include('common.min.js');
@@include('help_text.js');
@@include('page_cars_years.js');
@@include('page_disk_model.js');
@@include('scrollup.js');
@@include('search_cars.js');
@@include('search_disks.js');
@@include('delivery.js');

$(document).ready(function(){
    (function header() {
        var headerEle = function () {
            var $headerHeight = $('header').height();
            $('.hidden-header').css({'height': $headerHeight + "px"});
        };
        $(window).load(function () {
            headerEle();
        });
        $(window).resize(function (e) {
            if (screen.width > 992) {
                 $('.hidden-header').css({'height': 60 + "px"});
            } else {
                headerEle();
                setTimeout(cloneSrcImage, 201);
            }
        });
        (function () {
            var docElem = document.documentElement,
                didScroll = false,
                changeHeaderOn = 200;
            document.querySelector('header');
            function init_scroll() {
                window.addEventListener('scroll', function () {
                    if (!didScroll) {
                        didScroll = true;
                        setTimeout(scrollPage, 0);//250);
                    }
                }, false);
            }

            function scrollPage() {
                var sy = scrollY();
                if (sy >= changeHeaderOn) {
                    $('.top-bar').slideUp("500");
                    $("header").addClass("fixed-header");

                    if (/iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || $(window).width() < 479) {
                        $('.navbar-nav > li > a').css({
                            'padding-top': 0 + "px",
                            'padding-bottom': 0 + "px"
                        })
                    } else {
                        $('.navbar-nav > li > a').css({
                            'padding-top': 20 + "px",
                            'padding-bottom': 20 + "px"
                        })
                    }
                    ;
                }
                else {
                    $('.top-bar').slideDown("slow");
                    $("header").removeClass("fixed-header");

                    if (/iPhone|iPod|BlackBerry/i.test(navigator.userAgent) || $(window).width() < 479) {
                        $('.navbar-nav > li > a').css({
                            'padding-top': 0 + "px",
                            'padding-bottom': 0 + "px"
                        })
                    } else {
                        $('.navbar-nav > li > a').css({
                            'padding-top': 28 + "px",
                            'padding-bottom': 28 + "px"
                        })
                    }
                    ;

                }
                didScroll = false;
            }

            function scrollY() {
                return window.pageYOffset || docElem.scrollTop;
            }

            init_scroll();
        })();

        $('.owl-carousel').owlCarousel({
            loop:true,
            // autoWidth:true,
            autoplay:true,
            autoplayTimeout:8000,
            autoplayHoverPause:true,
            items:1,
            dots:true
        });

        $('.owl-carousel img').on('click', function() {
            var url = $(this).attr('href');
            window.location = url;
        });

        var hrefNav = $('.js-submenu');
        hrefNav.on('click', function (e) {
            e.preventDefault();
        });

        var navbarMenu = $('.js-navbar-menu');
        navbarMenu.on('click', function (e) {
            e.preventDefault();
            var $this = $(this);
            addClassActive($this.closest('div'));
        });

        function addClassActive($this) {
            if ($this.hasClass('active')) {
                $this.removeClass('active');
            } else {
              $this.addClass('active');
            }
        }

        var diskiSlider = $('.js-imageGallery-disks');
        diskiSlider.lightSlider({
            gallery:true,
            controls: false,
            item: 1,
            slideMove: 1,
            loop: true,
            thumbItem: 4,
            // thumbWidth: 25,
            // controls: true,
            thumbMargin: 10,
            slideMargin: 0,
            currentPagerPosition: 'middle',
            onSliderLoad: function(el) {
                cloneSrcImage();
            }
        }); 

        function cloneSrcImage() {
            var thumb = [];
            diskiSlider.find('.lslide:not(.clone)').each(function (i, e) {
               thumb.push($(e).children().data('thumb')); 
            });

            diskiSlider.closest('.lSSlideOuter').children('ul').find('img').each(function (j, el) {
                $(el).prop('src', thumb[j]);
            });
        }

        // sroll top for filter cars and disks
        (function scrollAnchor() {
            var anchor = window.location.hash;
            var commentAnchor;

            if (anchor.indexOf('#disks') > -1 || anchor.indexOf('#cars') > -1) {
                var commentAnchor = $(anchor);
            }

            if (anchor && commentAnchor) {
                $('html, body').animate({
                    scrollTop: commentAnchor.offset().top - 50
                }, 500);
            }
        })();

    })();
});
